import * as React from 'react';
import * as Theme from '@sail/theme-classic';

import {css} from '../css';
import {view} from '../view';

const styles = css({
  display: css.value('inline-flex'),
  alignItems: css.value('center'),
  whiteSpace: css.value('nowrap'),
});

export interface BadgeProps {
  /**
   * @external
   */
  type?: 'urgent' | 'warning' | 'negative' | 'positive' | 'info' | 'neutral';
}

/**
 * @external
 */
export const Badge = view.span.create<BadgeProps>(function Badge(
  {type = 'neutral', ...props},
  View,
) {
  return (
    <View
      uses={[props, styles, Theme.BadgeVariants.assign({type}), Theme.Badge]}
    />
  );
});
